module.exports = __webpack_public_path__ + "media/call-accepted.925bf342.mp3";